import { render, staticRenderFns } from "./SignHero.vue?vue&type=template&id=874cf682"
import script from "./SignHero.vue?vue&type=script&lang=js"
export * from "./SignHero.vue?vue&type=script&lang=js"
import style0 from "./SignHero.vue?vue&type=style&index=0&id=874cf682&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports